import { IApplicationState } from '../../types/redux';

const defaultSpecialtyTypes = Array.of<number>();

export function filterReadyBusinessTypesSelector(state: IApplicationState): Array<number> {
  return state.filters.jsonQuery.ready_business_types?.value ?? defaultSpecialtyTypes;
}
